import React from 'react';
import TablaAlumnos from './ABM/TablaAlumnos';

export default function Alumnos() {
	return (
		<div style={{ paddingRight: '2rem', paddingLeft: '2rem' }}>
			<TablaAlumnos />
		</div>
	);
}
